import * as mercator from 'global-mercator';
import vt2geojson from '@/lib/getVectorTile';
import pointInPolygon from '@turf/boolean-point-in-polygon'; ///dist/es/index.js';
// console.log(pointInPolygon);
async function queryLngLat(
    tilesUrl,
    lngLat,
    zoom,
    layer,
    options = { quiet: false }
) {
    const [x, y, z] = mercator.lngLatToGoogle(lngLat, zoom);
    const uri = tilesUrl
        .replace('{x}', x)
        .replace('{y}', y)
        .replace('{z}', z);
    try {
        const featureCollection = await vt2geojson({ uri, layer, x, y, z });
        const features = featureCollection.features.filter((f) =>
            pointInPolygon(lngLat, f)
        );
        if (features) {
            return {
                type: 'FeatureCollection',
                features,
            };
        }
    } catch (e) {
        if (!options.quiet) {
            console.error(e);
        }
    }
}
export { queryLngLat };
